<template>
	<main>
		<!-- <div class="page-header" style="margin-bottom: 0 !important;">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="행사정보" />
				</div>
			</div>
		</div> -->
		<div class="page-content" style="margin-top: 0 !important; padding-top: 0 !important;">
			<div class="container">
				<div class="information-content" style="text-align: center; position: relative; display: inline-block;">
					<img src="@/assets/img/information/dhIntroduce0226.jpg" alt="행사정보" style="max-width: 100%; height: auto; display: block;" />
					<router-link to="/ko/info/campnHistory" style="background: rgba(255,0,0,0);"></router-link>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import PageHeader from '@/components/content/PageHeader';
export default {
	name: 'Information',
	components: { PageHeader },
	data: () => ({}),
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	methods: {},
};
</script>
